/* Surgical insert only: absolute deadlines; no cart, offer or pricing mutation. */
(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-ngsbc-deadline]').forEach((root) => {
      if (root.dataset.ngsbcReady) return;
      root.dataset.ngsbcReady = 'true';
      const value = root.dataset.ngsbcDeadline;
      const deadline = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
      const clock = root.querySelector('[data-ngsbc-clock]');
      const timer = root.querySelector('[data-ngsbc-timer]');
      let interval;
      const update = () => {
        if (!root.isConnected) { clearInterval(interval); return; }
        const remaining = Math.ceil((deadline - Date.now()) / 1000);
        if (!Number.isFinite(remaining) || remaining <= 0) {
          timer?.remove();
          if (root.hasAttribute('data-ngsbc-timer-only')) root.hidden = true;
          clearInterval(interval);
          return;
        }
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor(remaining / 60) % 60;
        const seconds = remaining % 60;
        if (clock) clock.textContent = [hours, minutes, seconds].map(n => String(n).padStart(2, '0')).join(':');
        if (timer) timer.hidden = false;
      };
      update();
      if (Number.isFinite(deadline) && deadline > Date.now()) interval = setInterval(update, 1000);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
